<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <el-input prefix-icon="el-icon-search" clearable v-model="filter.searchText" style="width: 260px"
                placeholder="商品名称、编号、类型、供应商"></el-input>
      <label style="margin-left: 12px; margin-right: 8px">入库仓库</label>
      <warehouse-select v-model="filter.warehouse" select-all></warehouse-select>
      <label style="margin-left: 12px; margin-right: 8px">入库时间</label>
      <el-date-picker
        style="width: 130px"
        v-model="filter.begDate"
        type="date"
        placeholder="开始日期">
      </el-date-picker>
      <el-date-picker
        style="margin-left: 8px; width: 130px"
        v-model="filter.endDate"
        type="date"
        placeholder="结束日期">
      </el-date-picker>
      <el-button style="margin-left: 10px" @click="loadData">查询</el-button>
      <el-checkbox style="margin-left: 10px" v-model="filter.expire">过期商品</el-checkbox>
      <el-button type="danger" style="margin-left: 10px" @click="deleteItems">删除</el-button>
      <el-button><a :href="exportUrl">导出</a></el-button>
    </div>
    <el-table :data="goodsList_" class="table-border" header-cell-class-name="table-head" :max-height="tableHeight">
      <el-table-column width="50">
        <template #header>
          <el-checkbox v-model="selected" @change="selectAll"></el-checkbox>
        </template>
        <template #default="{ row }">
          <el-checkbox v-model="row.selected"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column label="商品编号" prop="code"></el-table-column>
      <el-table-column label="商品名称" prop="name"></el-table-column>
      <el-table-column label="商品类型">
        <template #default="{row}">
          {{ row.typeCode | valueName('GOODS_TYPE') }}
        </template>
      </el-table-column>
      <el-table-column label="仓库/库位">
        <template #default="{row}">
          <div>{{ row.warehouseId | valueName('Warehouse') }}
            - {{ row.warehousePosId | valueName('WarehousePos') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="保质期天数" prop="expireDaysFromNow"></el-table-column>
      <el-table-column label="单价（元）" prop="price"></el-table-column>
      <el-table-column label="单位" prop="unit"></el-table-column>
      <el-table-column label="金额">
        <template #default="{row}">
          {{ row.price * row.remain }}
        </template>
      </el-table-column>
      <el-table-column label="数量" prop="remain" width="100"></el-table-column>
      <el-table-column label="供应商">
        <template #default="{row}">
          {{ row.supplierCode | valueName('SUPPLIER') }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import WarehouseSelect from '@/components/selector/WarehouseSelect'
import { valueName } from '@/utils/filters'
import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'
import { findGoods, deleteInboundGoods } from '@/utils/request'

export default {
  name: 'InboundList',
  mixins: [resizeCaptureMixin],
  components: { WarehouseSelect },
  data () {
    return {
      loading: false,
      goodsList: [],
      filter: {
        searchText: null,
        warehouse: [null],
        begDate: null,
        endDate: null,
        expire: false
      },
      selected: false
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      findGoods({}).then(resp => {
        this.goodsList = resp.data
        for (const item of this.goodsList) {
          this.$set(item, 'selected', false)
        }
        this.loading = false
      })
    },
    selectAll () {
      for (const item of this.goodsList) {
        this.$set(item, 'selected', this.selected)
      }
    },
    deleteItems () {
      const items = this.goodsList_.filter(item => item.selected)
      const names = items.map(item => item.name).join('、')
      this.$confirm(`确认删除【${names}】, 是否继续?`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteInboundGoods(items).then(() => {
          this.$message.success('删除成功!')
          this.loadData()
        })
      }).catch(() => {
      })
    }
  },
  computed: {
    goodsList_ () {
      let list = this.goodsList

      if (this.filter.searchText) {
        list = list.filter(goods => {
          if (goods.name.indexOf(this.filter.searchText) >= 0) return true
          if (goods.code.indexOf(this.filter.searchText) >= 0) return true
          if (valueName(goods.typeCode, 'GOODS_TYPE').indexOf(this.filter.searchText) >= 0) return true
          if (valueName(goods.supplierCode, 'SUPPLIER').indexOf(this.filter.searchText) >= 0) return true
          return false
        })
      }

      if (this.filter.warehouse[0]) {
        list = list.filter(goods => {
          return goods.warehouseId === this.filter.warehouse[0] && goods.warehousePosId === this.filter.warehouse[1]
        })
      }

      if (this.filter.begDate !== null) {
        list = list.filter(goods => {
          return this.filter.begDate.format('yyyy-MM-dd') <= goods.inboundDate
        })
      }

      if (this.filter.endDate !== null) {
        list = list.filter(goods => {
          return this.filter.endDate.format('yyyy-MM-dd') >= goods.inboundDate
        })
      }

      if (this.filter.expire) {
        list = list.filter(goods => {
          return goods.expireDaysFromNow < 0
        })
      }

      return list
    },
    tableHeight () {
      return this.clientHeight - 224
    },
    exportUrl () {
      const filter = this.$_.cloneDeep(this.filter)
      if (filter.begDate) {
        filter.begDate = filter.begDate.formatDate()
      }
      if (filter.endDate) {
        filter.endDate = filter.endDate.formatDate()
      }

      return this.$baseUrl + 'api/downloadRemainGoodsList?filterStr=' + encodeURIComponent(JSON.stringify(filter))
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ th {
  height: 50px;
}

label {
  margin-right: 10px;
  font-size: 13px;
  color: #646464;
}
</style>
